import Localization from "../../../../localization";
import { Text } from "../../../../components";
import { Flex } from "antd";

const Ajax = ({ alarmModel }) => {
  return (
    <Flex gap={"1em"} align="center">
      {!!alarmModel.image && (
        <img src={alarmModel.image} style={{ height: "4.4rem" }} />
      )}
      <Flex justify="space-between" flex={1} className="flex-column-mobile">
        <div>
          <Text level={5} weight={700} children={alarmModel?.name} />
          <Text
            color="secondary"
            children={`Hub ID: ${
              alarmModel?.identifier ?? Localization.general.not_connected
            }`}
          />
        </div>
        <Text
          weight={600}
          color="secondary"
          children={Localization.general.connected.toUpperCase()}
        />
      </Flex>
    </Flex>
  );
};

export default Ajax;
